export default __webpack_public_path__ + "static/media/gruexpress.2715465e.jpg";